import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { CaregiverCallConfirmationType } from '@/shared/call/CaregiverCallConfirmationType';

import { CallStatus } from './CallStatus';
import {
    callStatusAtom,
    confirmationTypeAtom,
    consultationUidAtom,
    internalOnCloseAtom,
} from './store';

type UseSyncCaregiverCallConfirmationDataProps = {
    confirmationType: CaregiverCallConfirmationType;
    consultationUid: string;
    onClose: () => void;
};

export const useSyncCaregiverCallConfirmationData = ({
    confirmationType,
    consultationUid,
    onClose,
}: UseSyncCaregiverCallConfirmationDataProps) => {
    const setCallStatus = useSetAtom(callStatusAtom);
    const setConfirmationType = useSetAtom(confirmationTypeAtom);
    const setConsultationUid = useSetAtom(consultationUidAtom);
    const setInternalOnClose = useSetAtom(internalOnCloseAtom);

    useEffect(() => {
        setConfirmationType(confirmationType);
        setConsultationUid(consultationUid);
        setInternalOnClose(() => onClose);
        setCallStatus(CallStatus.notStarted);
    }, [
        confirmationType,
        consultationUid,
        onClose,
        setConfirmationType,
        setConsultationUid,
        setInternalOnClose,
        setCallStatus,
    ]);
};
